import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { PRIMARIES, PRIMARIESWITHOLYMPIC } from "../../../constants";
import Modal from "../../../parts/modal-new";

// `inForm`: rendered inside a form whose submit has side effects (the signup
// wizard), so Cancel/Save must only close the modal. Settings relies on Save
// submitting its preferences form, so it keeps the default.
const CollectRepMaxModal = ({
  userToBindInformation,
  notAbleToEdit,
  inForm = false,
}) => {
  const { t } = useTranslation("dashboard");
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenModal = () => setIsOpen((prev) => !prev);
  const footerButtonType = inForm ? "button" : "submit";
  const { collectRepMax, hideRepMaximums } = userToBindInformation;
  return (
    <>
      <button
        type="button"
        disabled={notAbleToEdit}
        data-button-type="tertiary"
        onClick={(e) => {
          e.preventDefault();
          handleOpenModal();
        }}
      >
        {t("collectRepMaxModal.custom")}
      </button>
      <Modal
        title={t("collectRepMaxModal.title")}
        className={isOpen ? "custom-rest-modal" : "hidden!"}
        onClose={(e) => {
          e.preventDefault();
          setIsOpen(false);
        }}
      >
        <div className="body">
          {PRIMARIESWITHOLYMPIC.map((primary) => {
            const defaultChecked =
              collectRepMax?.includes(primary) ||
              (PRIMARIES.includes(primary) &&
                !collectRepMax?.length &&
                !hideRepMaximums);
            return (
              <div
                key={`collect-${primary}`}
                className="flex items-center gap-2"
              >
                <input
                  type="checkbox"
                  name={`collectRepMax[${primary}]`}
                  id={`collectRepMax[${primary}]`}
                  defaultChecked={defaultChecked}
                />
                <label
                  htmlFor={`collectRepMax[${primary}]`}
                  className="capitalize"
                >
                  {t(`collectRepMaxModal.${primary}`)}
                </label>
              </div>
            );
          })}
        </div>
        <footer>
          <button
            type={footerButtonType}
            data-button-type="secondary"
            data-action="cancel"
            onClick={handleOpenModal}
          >
            {t("common:cancel")}
          </button>
          <button
            type={footerButtonType}
            data-button-type="primary"
            onClick={handleOpenModal}
          >
            {t("common:save")}
          </button>
        </footer>
      </Modal>
    </>
  );
};

export default CollectRepMaxModal;
